import React from "react";
import { AEMetadata } from "../../../../../../_emywork/AEPagination";
import { EditLayout } from "../../../../common/hooks";
import {
  TRANSACTIONS_CONTEXT,
  TRANSACTIONS_CONTEXT_TITLE,
} from "../../../helpers/ModuleHelpers";
import { useModuleContext } from "../../../ModuleContext";
import { actionTypes } from "../../../_redux/transactions/slice";
import EditForm from "../transactions/EditForm";
import * as actions from "../../../_redux/transactions/actions";
//TODO: refactor code DRY
const metadata = new AEMetadata(
  {
    perPage: 12,
  },
  //sort
  {},
  //filters
  {},
  // select
  ["*", "user", "payment_method"]
);
const TransactionsEdit = ({
  history,
  match: {
    params: { id },
  },
}) => {
  useModuleContext();

  return (
    <>
      <EditLayout
        CONTEXT={TRANSACTIONS_CONTEXT}
        CONTEXT_TITLE={TRANSACTIONS_CONTEXT_TITLE}
        id={id}
        metadata={metadata}
        history={history}
        EditForm={EditForm}
        actions={actions}
        actionTypes={actionTypes}
        useModuleContext={useModuleContext}
        deleteModalTitle="Transactions"
      />
    </>
  );
};

export default TransactionsEdit;
